import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';

class UltraPhaserEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let compressor = this.state.effect.compressorNode;
        let gainNode = this.state.effect.effectNode;
        let className = this.props.automation !== undefined ?
            'enabled tall-effect effect effect-automation' :
            this.state.effect.isEnabled() ? 'tall-effect effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                      <EffectParameterSlider
                            effectNumber={this.props.effectNumber}
                            automation={this.props.automation}
                            name='Rate'
                            selectedParameter={this.props.selectedParameter}
                            sequencerEngine={this.props.sequencerEngine}
                            lfoEnabled={true}
                            parameter={this.state.effect.rateParameter}
                            isParameter={true}
                            onParameterChanged={this.props.onParameterChanged}
                            step={0.001}
                            max={20}
                            min={0}
                            />
                      <EffectParameterSlider
                            effectNumber={this.props.effectNumber}
                            automation={this.props.automation}
                            name='Feedback'
                            selectedParameter={this.props.selectedParameter}
                            sequencerEngine={this.props.sequencerEngine}
                            lfoEnabled={true}
                            parameter={this.state.effect.feedbackParameter}
                            isParameter={true}
                            onParameterChanged={this.props.onParameterChanged}
                            step={0.001}
                            max={1}
                            min={0}
                            />

                      <EffectParameterSlider
                            effectNumber={this.props.effectNumber}
                            automation={this.props.automation}
                            name='Depth'
                            selectedParameter={this.props.selectedParameter}
                            sequencerEngine={this.props.sequencerEngine}
                            lfoEnabled={true}
                            parameter={this.state.effect.depthParameter}
                            isParameter={true}
                            onParameterChanged={this.props.onParameterChanged}
                            step={0.01}
                            max={1}
                            min={0}
                            />

                      <EffectParameterSlider
                            effectNumber={this.props.effectNumber}
                            automation={this.props.automation}
                            name='Wet'
                            selectedParameter={this.props.selectedParameter}
                            sequencerEngine={this.props.sequencerEngine}
                            lfoEnabled={true}
                            parameter={this.state.effect.wetParameter}
                            isParameter={true}
                            onParameterChanged={this.props.onParameterChanged}
                            step={0.001}
                            max={1}
                            min={0}
                            />
                </div>} 
            </div>
        );
    }
}

export default UltraPhaserEffect;
